<h3>{{popup.title}}</h3>
<h5 *ngIf="popup.subTitle">{{popup.subTitle}}</h5>
<form (ngSubmit)="onSubmit()" [formGroup]="archiveCardForm" class="archiveCards">
  <mat-form-field appearance="outline">
    <mat-select placeholder="Select condition" [formControl]="archiveCardForm.controls['condition']">
      <mat-option value="eq">ON</mat-option>
      <mat-option value="lt">BEFORE</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <input matInput [owlDateTime]="date" [owlDateTimeTrigger]="date" placeholder="select date" formControlName="date">
    <owl-date-time pickerType="calendar" #date></owl-date-time>
    <mat-datepicker-toggle matSuffix [owlDateTimeTrigger]="date"></mat-datepicker-toggle>
  </mat-form-field>
  <button class="m-b-15" color="primary" mat-raised-button type="submit">Submit</button>
</form>